import { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'antd';
import i10n from '../../common/i10n';
import { AsyncSVG } from './AsyncSVG';

export class ReloadComponent extends PureComponent {

    reload = () => {
        if (this.props.onReload) {
            this.props.onReload();
        }
    }

    render() {
        if (this.props.buttonView) {
            return (
                <Button className={`action-button mt-3 mb-3 ${this.props.buttonColor}`} onClick={this.reload}>
                    {i10n._VIEW_TOOL_LAYOUT_BUTTON_START_OVER}
                </Button>
            );
        }
        else
            return <AsyncSVG className="reload" onClick={this.reload} title={i10n._VIEW_TOOL_LAYOUT_BUTTON_START_OVER} src="/images/reload.svg" />;
    }
}

const mapDispatch = (dispatch) => {
    return {
    }
}

const Reload = withRouter(connect(() => ({}), mapDispatch)(ReloadComponent));
export default Reload;